import makeUseStyles from "@assets/style/util/makeUseStyles"
import {
  MentionedGroupSuggestion,
  MentionedUserSuggestion,
} from "@components/chat/channel/trigger/hooks/useMentionTrigger"
import { DiscoText } from "@disco-ui"
import { ReactNode } from "react"

type ChatMessageMentionProps = {
  children?: ReactNode
  node: {
    mentionedUser?: MentionedUserSuggestion
    mentionedGroup?: MentionedGroupSuggestion
  }
}

function ChatMessageMention(props: ChatMessageMentionProps) {
  const {
    children,
    node: { mentionedUser, mentionedGroup },
  } = props

  const classes = useStyles()

  if (mentionedUser) {
    return (
      <DiscoText
        variant={"body-md-700"}
        color={"primary.main"}
        className={classes.userMention}
        // Need to include this to make the user popover work
        data-user-id={mentionedUser.id}
        component={"span"}
      >
        {children}
      </DiscoText>
    )
  }

  if (mentionedGroup) {
    return (
      <DiscoText variant={"body-md-700"} color={"primary.main"} component={"span"}>
        {children}
      </DiscoText>
    )
  }

  return null
}

const useStyles = makeUseStyles({
  userMention: {
    cursor: "pointer",
  },
})

export default ChatMessageMention
